
import { defineComponent } from "vue";
import { SwitchGroup, Switch, SwitchLabel } from "@headlessui/vue";

export default defineComponent({
  name: "Toggle",
  props: {
    toggled: Boolean,
    label: String,
  },
  data: function() {
    return {
      innerToggled: this.toggled,
    };
  },
  components: {
    SwitchGroup,
    Switch,
    SwitchLabel,
  },
  methods: {
    changed: function(toggled: boolean) {
      console.log("changed", toggled);
      this.$emit("change", toggled);
    },
  },
  created() {
    this.innerToggled = this.toggled;
  },
  updated() {
    this.innerToggled = this.toggled;
  },
  watch: {
    innerToggled(toggled) {
      console.log("watch", toggled);
      this.$emit("change", toggled);
    },
  },
});
